// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as V2i$Linear from "lumi-linear/lib/es6/src/V2i.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Stdlib_String from "@rescript/runtime/lib/es6/Stdlib_String.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let jsonCodec = Jzon.custom(v => {
  let tmp;
  switch (v) {
    case "HAlignLeft" :
      tmp = "HAlignLeft";
      break;
    case "HAlignCenter" :
      tmp = "HAlignCenter";
      break;
    case "HAlignRight" :
      tmp = "HAlignRight";
      break;
  }
  return Jzon.encodeWith(tmp, Jzon.string);
}, json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), str => {
  switch (str) {
    case "HAlignCenter" :
      return {
        TAG: "Ok",
        _0: "HAlignCenter"
      };
    case "HAlignLeft" :
      return {
        TAG: "Ok",
        _0: "HAlignLeft"
      };
    case "HAlignRight" :
      return {
        TAG: "Ok",
        _0: "HAlignRight"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            str
          ]
        }
      };
  }
}));

let HAlign = {
  jsonCodec: jsonCodec
};

let jsonCodec$1 = Jzon.custom(v => {
  let tmp;
  switch (v) {
    case "VAlignTop" :
      tmp = "VAlignTop";
      break;
    case "VAlignCenter" :
      tmp = "VAlignCenter";
      break;
    case "VAlignBottom" :
      tmp = "VAlignBottom";
      break;
  }
  return Jzon.encodeWith(tmp, Jzon.string);
}, json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), str => {
  switch (str) {
    case "VAlignBottom" :
      return {
        TAG: "Ok",
        _0: "VAlignBottom"
      };
    case "VAlignCenter" :
      return {
        TAG: "Ok",
        _0: "VAlignCenter"
      };
    case "VAlignTop" :
      return {
        TAG: "Ok",
        _0: "VAlignTop"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            str
          ]
        }
      };
  }
}));

let VAlign = {
  jsonCodec: jsonCodec$1
};

let jsonCodec$2 = Jzon.custom(v => {
  let tmp;
  switch (v) {
    case "TransformCrop" :
      tmp = "TransformCrop";
      break;
    case "TransformScale" :
      tmp = "TransformScale";
      break;
    case "TransformThumbnail" :
      tmp = "TransformThumbnail";
      break;
    case "TransformFit" :
      tmp = "TransformFit";
      break;
    case "TransformTile" :
      tmp = "TransformTile";
      break;
  }
  return Jzon.encodeWith(tmp, Jzon.string);
}, json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), str => {
  switch (str) {
    case "TransformCrop" :
      return {
        TAG: "Ok",
        _0: "TransformCrop"
      };
    case "TransformFit" :
      return {
        TAG: "Ok",
        _0: "TransformFit"
      };
    case "TransformScale" :
      return {
        TAG: "Ok",
        _0: "TransformScale"
      };
    case "TransformThumbnail" :
      return {
        TAG: "Ok",
        _0: "TransformThumbnail"
      };
    case "TransformTile" :
      return {
        TAG: "Ok",
        _0: "TransformTile"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            str
          ]
        }
      };
  }
}));

let Transform = {
  jsonCodec: jsonCodec$2
};

let jsonCodec$3 = Jzon.custom(v => {
  let tmp;
  switch (v) {
    case "FilterNearest" :
      tmp = "FilterNearest";
      break;
    case "FilterBilinear" :
      tmp = "FilterBilinear";
      break;
    case "FilterBicubic" :
      tmp = "FilterBicubic";
      break;
    case "FilterAntiAlias" :
      tmp = "FilterAntiAlias";
      break;
  }
  return Jzon.encodeWith(tmp, Jzon.string);
}, json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), str => {
  switch (str) {
    case "FilterAntiAlias" :
      return {
        TAG: "Ok",
        _0: "FilterAntiAlias"
      };
    case "FilterBicubic" :
      return {
        TAG: "Ok",
        _0: "FilterBicubic"
      };
    case "FilterBilinear" :
      return {
        TAG: "Ok",
        _0: "FilterBilinear"
      };
    case "FilterNearest" :
      return {
        TAG: "Ok",
        _0: "FilterNearest"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            str
          ]
        }
      };
  }
}));

let Filter = {
  jsonCodec: jsonCodec$3
};

let jsonCodec$4 = Jzon.object5(param => [
  param.text,
  param.font,
  param.hAlign,
  param.vAlign,
  param.fill
], param => ({
  TAG: "Ok",
  _0: {
    text: param[0],
    font: param[1],
    hAlign: param[2],
    vAlign: param[3],
    fill: param[4]
  }
}), Jzon.field("text", Jzon.string), Jzon.field("font", Jzon.string), Jzon.field("hAlign", jsonCodec), Jzon.field("vAlign", jsonCodec$1), Jzon.field("fill", Jzon.string));

let DrawText = {
  jsonCodec: jsonCodec$4
};

let jsonCodec$5 = Jzon.object3(param => [
  param.transform,
  param.filter,
  param.image
], param => ({
  TAG: "Ok",
  _0: {
    transform: param[0],
    filter: param[1],
    image: param[2]
  }
}), Jzon.field("transform", jsonCodec$2), Jzon.field("filter", jsonCodec$3), Jzon.field("image", Jzon.string));

let DrawImage = {
  jsonCodec: jsonCodec$5
};

let jsonCodec$6 = Jzon.object3(param => [
  param.points,
  param.fill,
  param.outline
], param => ({
  TAG: "Ok",
  _0: {
    points: param[0],
    fill: param[1],
    outline: param[2]
  }
}), Jzon.field("points", Jzon.array(LumiJzon.tuple2(Jzon.int, Jzon.int))), Jzon.field("fill", Jzon.string), Jzon.field("outline", Jzon.string));

let DrawPolygon = {
  jsonCodec: jsonCodec$6
};

let jsonCodec$7 = LumiJzon.taggedVariant(value => {
  switch (value.TAG) {
    case "DrawInRectText" :
      return [
        "DrawInRectText",
        Jzon.encodeWith(value._0, jsonCodec$4)
      ];
    case "DrawInRectImage" :
      return [
        "DrawInRectImage",
        Jzon.encodeWith(value._0, jsonCodec$5)
      ];
    case "DrawInRectPolygon" :
      return [
        "DrawInRectPolygon",
        Jzon.encodeWith(value._0, jsonCodec$6)
      ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "DrawInRectImage" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$5), drawImage => ({
        TAG: "DrawInRectImage",
        _0: drawImage
      }));
    case "DrawInRectPolygon" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$6), drawPolygon => ({
        TAG: "DrawInRectPolygon",
        _0: drawPolygon
      }));
    case "DrawInRectText" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$4), drawText => ({
        TAG: "DrawInRectText",
        _0: drawText
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let DrawInRect = {
  jsonCodec: jsonCodec$7
};

let jsonCodec$8 = Jzon.object4(param => [
  param.pos,
  param.size,
  param.rotation,
  param.draw
], param => ({
  TAG: "Ok",
  _0: {
    pos: param[0],
    size: param[1],
    rotation: param[2],
    draw: param[3]
  }
}), Jzon.field("pos", LumiJzon.tuple2(Jzon.int, Jzon.int)), Jzon.field("size", LumiJzon.tuple2(Jzon.int, Jzon.int)), Jzon.field("rotation", Jzon.int), Jzon.field("draw", jsonCodec$7));

function LumiDrawCommand$LumiDrawCommand$SVG(props) {
  let match = props.command;
  let draw = match.draw;
  let size = match.size;
  let pos = match.pos;
  switch (draw.TAG) {
    case "DrawInRectText" :
      let match$1 = draw._0;
      let font = match$1.font;
      let match$2 = V2$Linear.map(pos, prim => prim);
      let fY = match$2[1];
      let fX = match$2[0];
      let match$3 = V2$Linear.map(size, prim => prim);
      let fHeight = match$3[1];
      let fWidth = match$3[0];
      let match$4;
      switch (match$1.hAlign) {
        case "HAlignLeft" :
          match$4 = [
            fX,
            "start"
          ];
          break;
        case "HAlignCenter" :
          match$4 = [
            fX + fWidth * 0.5,
            "middle"
          ];
          break;
        case "HAlignRight" :
          match$4 = [
            fX + fWidth,
            "end"
          ];
          break;
      }
      let match$5;
      switch (match$1.vAlign) {
        case "VAlignTop" :
          match$5 = [
            fY,
            "text-top"
          ];
          break;
        case "VAlignCenter" :
          match$5 = [
            fY + fHeight * 0.5,
            "middle"
          ];
          break;
        case "VAlignBottom" :
          match$5 = [
            fY + fHeight,
            "text-bottom"
          ];
          break;
      }
      let match$6 = V2f$Linear.mapToString([
        match$4[0],
        match$5[0]
      ]);
      let idx = Stdlib_String.lastIndexOfOpt(font, ":");
      let match$7 = idx !== undefined ? [
          font.slice(0, idx),
          Stdlib_Int.fromString(font.slice(idx + 1 | 0), 10)
        ] : [
          font,
          undefined
        ];
      let fontSize = Stdlib_Option.getOr(match$7[1], 12).toString() + "px";
      let match$8;
      switch (match$7[0]) {
        case "DejaVuSansMono-Bold" :
          match$8 = [
            "'DejaVu Sans Mono Bold', monospace",
            "bold"
          ];
          break;
        case "Sofia_Pro_Bold" :
          match$8 = [
            "'Sofia Pro Bold', sans-serif",
            "bold"
          ];
          break;
        case "selawkb" :
          match$8 = [
            "'Selawik Bold', 'Segoe UI', sans-serif",
            "bold"
          ];
          break;
        case "selawksb" :
          match$8 = [
            "'Selawik Semibold', 'Segoe UI', sans-serif",
            "600"
          ];
          break;
        case "sq" :
          match$8 = [
            "sq, monospace",
            "normal"
          ];
          break;
        case "sqb" :
          match$8 = [
            "sqBold, monospace",
            "bold"
          ];
          break;
        default:
          match$8 = [
            "default",
            "normal"
          ];
      }
      return JsxRuntime.jsx("text", {
        children: match$1.text,
        dominantBaseline: match$5[1],
        fill: match$1.fill,
        fontFamily: match$8[0],
        fontSize: fontSize,
        fontWeight: match$8[1],
        stroke: "none",
        textAnchor: match$4[1],
        x: match$6[0],
        y: match$6[1]
      });
    case "DrawInRectImage" :
      let image = draw._0.image;
      let match$9 = V2$Linear.map(pos, x => x.toString());
      let match$10 = V2$Linear.map(size, x => x.toString());
      let href = "/static-display-data/images/" + image;
      return JsxRuntime.jsx("image", {
        alt: image,
        height: match$10[1],
        href: href,
        width: match$10[0],
        x: match$9[0],
        y: match$9[1]
      });
    case "DrawInRectPolygon" :
      let match$11 = draw._0;
      let points = match$11.points.map(extra => V2i$Linear.plus(pos, extra)).map(p => {
        let match = V2$Linear.map(p, x => x.toString());
        return match[0] + "," + match[1];
      }).join(" ");
      return JsxRuntime.jsx("polygon", {
        fill: match$11.fill,
        points: points,
        stroke: match$11.outline,
        strokeWidth: "1"
      });
  }
}

let SVG = {
  make: LumiDrawCommand$LumiDrawCommand$SVG
};

let LumiDrawCommand = {
  jsonCodec: jsonCodec$8,
  SVG: SVG
};

function LumiDrawCommand$Tags(props) {
  return JsxRuntime.jsx("div", {
    children: props.commands.map((param, idx) => {
      let draw = param.draw;
      switch (draw.TAG) {
        case "DrawInRectText" :
          let match = draw._0;
          return JsxRuntime.jsx("span", {
            children: match.text,
            className: "tag is-black has-text-weight-semibold",
            style: {
              color: match.fill
            }
          }, idx.toString());
        case "DrawInRectImage" :
          return JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                  name: "image"
                }),
                className: "icon"
              }),
              JsxRuntime.jsx("span", {
                children: draw._0.image
              })
            ],
            className: "tag is-primary is-family-monospace"
          }, idx.toString());
        case "DrawInRectPolygon" :
          return JsxRuntime.jsx("span", {
            children: "\xa0",
            className: "tag",
            style: {
              backgroundColor: draw._0.fill
            }
          }, idx.toString());
      }
    }),
    className: "tags"
  });
}

let Tags = {
  make: LumiDrawCommand$Tags
};

export {
  HAlign,
  VAlign,
  Transform,
  Filter,
  DrawText,
  DrawImage,
  DrawPolygon,
  DrawInRect,
  LumiDrawCommand,
  Tags,
}
/* jsonCodec Not a pure module */
